import {
    Breadcrumb,
    IBreadcrumbItem,
    Link,
    mergeStyles,
    Text,
    useTheme
} from "@fluentui/react"
import { RootState } from "app/store"
import { trimGUIDLower } from "global/Utility/TSFunctions"
import { bcbs_groupconfigurationsnapshot } from "model/AttributeOptionSets.type"
import { useMemo } from "react"
import { connect, ConnectedProps } from 'react-redux'
import { useHistory } from "react-router"
import withBreadcrumbs from "react-router-breadcrumbs-hoc"
import { AppNavigateToExternal } from "."

interface IProps extends TComponentConnectedProps {
    breadcrumbs: { breadcrumb: any, match?: any }[];
}

const BreadcrumbNavigation = (props: IProps) => {

    const history = useHistory();

    const theme = useTheme();

    const secondaryClass = useMemo(() => {
        return mergeStyles({
            padding: '3px',
            paddingLeft: '6px',
            paddingRight: '6px',
            border: '1px solid transparent',
            margin: '2px',
            boxSizing: 'border-box',
            borderRadius: '4px',
            "&:hover": {
                textDecoration: 'none',
                backgroundColor: theme.palette.white,
                border: '1px solid gray',
                transition: 'all 0.4s',

            },
            "&:active:hover": {
                textDecoration: 'none',
            }

        });
    }, [theme]);

    const items: IBreadcrumbItem[] = [];
    props.breadcrumbs.forEach((b, i) => {

        if (b === null)
            return;

        let onClick = () => {
            history.push(b.match.url);
        }

        if (i < 1) { return; }
        let text: string | null = null;
        let resource = props.breadcrumbs[i - 1].breadcrumb.props.children;
        const resourceId = props.breadcrumbs[i].breadcrumb.props.children;

        if (resource === "GroupConfiguration") {
            text = `${props.state?.data?.snapshot?.bcbs_name}`;

            // marking gold standard
            if (props.state?.data?.snapshot?.statuscode === bcbs_groupconfigurationsnapshot.statuscode["Gold Standard(808900006)"].value)
                resource = resource + ' 🥇';
            else if (
                props.state?.data?.snapshot?.statuscode === bcbs_groupconfigurationsnapshot.statuscode["Cancellation in Progress(808900013)"].value
                || props.state?.data?.snapshot?.statuscode === bcbs_groupconfigurationsnapshot.statuscode["Cancelled(808900011)"].value
            )
                resource = resource + ' ❌';
        }
        else if (resource === "BlueRelationship") {
            text = `${props.state?.status?.account?.name}`;
            onClick = () => {
                AppNavigateToExternal(history, props.state, 'crm-account');
            }
        }
        else if (resource === "Plan") {
            const planIdUrl = resourceId;
            const planId = trimGUIDLower(planIdUrl);
            const plan = props.state?.data.json?.plans?.find((t) => t.id === planId)
            text = `${plan?.name ?? "Plan"}`;

        }
        //add more cases here for deeper layers
        else if (resource === "Benefit") {
            const id = trimGUIDLower(resourceId);
            const benefit = props.state?.data.json?.benefits?.find((t) => t.id === id)
            text = `${benefit?.name ?? "Benefit"}`;
            resource = resource + ` (${benefit?.bcbs_name})`

        } else if (resource === "FeesAndPremium") {
            const id = trimGUIDLower(resourceId);
            const feesAndPremium = props.state?.data.json?.feesAndPremiums?.find((t) => t.id === id)
            text = `${feesAndPremium?.name ?? ""}`;

        } else if (resource === "StopLoss") {
            const id = trimGUIDLower(resourceId);
            const stopLoss = props.state?.data.json?.stopLoss?.find((t) => t.id === id)
            text = `${stopLoss?.name ?? ""}`;

        } else if (resource === "ClaimsAR") {
            const id = trimGUIDLower(resourceId);
            const claimsAR = props.state?.data.json?.claimsARs?.find((t) => t.id === id)
            text = `${claimsAR?.name ?? ""}`;
            resource = "Accounts Receivable";
        }
        else if (resourceId === "Nonstandardtemplates") { //this is very....BRUTE FORCE
            //const id = trimGUIDLower(resource);
            text = `Non-Standards`;
            resource = "Non-Standard Templates";
        }
        else if (resource === "Checklist" && resourceId === "List") {
            text = `E&M CheckList`;
            resource = "E&M CheckList";
        } else if (resource === "Checklist" && resourceId !== "List") {
            items.push({
                onClick: () => {
                    history.push(props.breadcrumbs[i - 1].match.url + "/list");
                },
                text: "E&M CheckList",
                key: props.breadcrumbs[i - 1].match.url,
                data: "E&M CheckList",
            });
            const id = trimGUIDLower(resourceId);
            const checkList = props.state?.data.checkList?.find(c => c.bcbs_emchecklist.bcbs_emchecklistid === id);

            text = `${checkList?.bcbs_emchecklist.bcbs_name}`;
            resource = "Plan";
        }
        else {
            return;
        }

        items.push({
            onClick: onClick,
            text: text,
            key: b.match.url,
            data: resource,
        });
    })




    return (
        <div>
            <Breadcrumb
                items={items}
                onRenderItem={(props, defaultRender) => {
                    return <Link onClick={props?.onClick} className={secondaryClass} >
                        <div>
                            <Text variant="medium">
                                {props?.text}
                            </Text>
                        </div>
                        <div>
                            <Text variant="xSmall">
                                {props?.data}
                            </Text>
                        </div>
                    </Link>
                }}
                maxDisplayedItems={10}
                styles={{
                    root: {
                        selectors: {
                            '.ms-TooltipHost': {
                                fontSize: 'medium'
                            }
                        }
                    }
                }}
            // onRenderItem={undefined}
            />
        </div>
    )
}

function mapStateToProps(state: RootState) { return { state } }
const connector = connect(mapStateToProps);
type TComponentConnectedProps = ConnectedProps<typeof connector | typeof withBreadcrumbs>;
//@ts-expect-error
export default connect(mapStateToProps)(withBreadcrumbs()(BreadcrumbNavigation));